import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import { LocalStorageService } from '@core/services/local-storage.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const localStorageService = inject(LocalStorageService);
  const selectedCustomerIds = (
    localStorageService.getItem<number[]>('selectedCustomerIds') ?? []
  ).join(',');

  const accessToken = authService.currentUser()?.token;

  if (accessToken) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${accessToken}`,
        'Accept-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
        'X-Customer-Ids': selectedCustomerIds,
      },
    });
  }
  return next(req);
};
